import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import type ResumePersonalInfo from "@/interface/ResumePersonalInfo";

//Biometric Data Auto Population
export default function setBiometricInfo(
  ccFormValue: Ref<FormCC>,
  prop: any,
  biometricVerification: Ref<string>,
  resumeInfo: Ref<ResumePersonalInfo>
) {
  if (prop.type == "BIO" && prop.biometricCardList) {
    if (prop.refNo) ccFormValue.value.refNo = prop.refNo;
    if (prop.biometricCardList.name)
      ccFormValue.value.basicInformation.name =
        prop.biometricCardList.name.toUpperCase();
    if (prop.biometricCardList.nric) {
      ccFormValue.value.basicInformation.idNo = prop.biometricCardList.nric;
      resumeInfo.value.idNo = prop.biometricCardList.nric;
      resumeInfo.value.idType = "0";
      ccFormValue.value.basicInformation.idType = "0";
    }
    if (prop.biometricCardList.dob)
      ccFormValue.value.basicInformation.dob = prop.biometricCardList.dob;
    if (prop.biometricCardList.gender)
      ccFormValue.value.personalInformation.gender =
        prop.biometricCardList.gender;
    if (prop.biometricCardList.address1)
      ccFormValue.value.personalInformation.residentialAddress1 =
        prop.biometricCardList.address1.toUpperCase();
    if (prop.biometricCardList.address2)
      ccFormValue.value.personalInformation.residentialAddress2 =
        prop.biometricCardList.address2.toUpperCase();
    if (prop.biometricCardList.address3)
      ccFormValue.value.personalInformation.residentialAddress3 =
        prop.biometricCardList.address3.toUpperCase();
    if (prop.biometricCardList.city)
      ccFormValue.value.personalInformation.city = prop.biometricCardList.city;
    if (prop.biometricCardList.postal)
      ccFormValue.value.personalInformation.postCode =
        prop.biometricCardList.postal;
    if (prop.biometricCardList.state)
      ccFormValue.value.personalInformation.state =
        prop.biometricCardList.state;
    if (prop.biometricCardList.biometricVerification) {
      biometricVerification.value =
        prop.biometricCardList.biometricVerification;
    }
  }
}
